import { ExtractRegistry } from './extract-registry';

export function DeclareExtract(name: string) {
  return function (target: any) {
    ExtractRegistry.declare(name, target);
  };
}
